import { Epic, ofType } from "redux-observable";
import { concat, of } from "rxjs";
import { exhaustMap } from "rxjs/operators";
import { SaveEmission } from "../../emission/actions/default";
import { RootState } from "../../reducers";
import { QutationPaymentActions } from "../actions";
import { QuotationPaymentSubmit } from "../actions/default";
import { QUOTATION_PAYMENT_SUBMIT } from "../constants";

export const quotationPaymentSubmitEpic: Epic<
    QutationPaymentActions,
    QutationPaymentActions,
    RootState
> = (action$) =>
    action$.pipe(
        ofType<QutationPaymentActions, QuotationPaymentSubmit>(
            QUOTATION_PAYMENT_SUBMIT
        ),
        exhaustMap(() => concat(of(new SaveEmission().create())))
    );
